(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/components/national-self-exclusion.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/components/national-self-exclusion.js');
'use strict';

const Button = svs.ui.ReactButton;
const Icon = svs.ui.ReactIcon;
const {
  Constants
} = svs.selfExclusion;
const NationalSelfExclusion = () => {
  const trackInteraction = e => {
    e.preventDefault();
    svs.components.analytics.trackEvent({
      action: 'Submit',
      category: 'spelpaus',
      opt_label: 'NarPaus',
      opt_value: 0
    });
    window.open(Constants.URL.EXCLUSION, '_blank', 'noopener');
  };
  return React.createElement(React.Fragment, null, React.createElement("section", {
    className: "exclusion-pause-wrapper padding-xs-h-1 padding-xs-bottom-2"
  }, React.createElement("div", null, React.createElement("h2", {
    className: "align-center f-700 f-bold"
  }, "Nationell avst\xE4ngning"), React.createElement("p", null, "G\xE5 till Spelinspektionens sida spelpaus.se f\xF6r att l\xE4sa mer om hur du st\xE4nger av dig fr\xE5n alla spelbolag med licens i Sverige.")), React.createElement(Button, {
    block: true,
    iconPosition: "right",
    inverted: true,
    linktitle: Constants.NATIONAL,
    onClick: trackInteraction,
    size: 300
  }, React.createElement(Icon, {
    icon: "link-external"
  }), "Till spelpaus.se")), React.createElement("hr", {
    "aria-hidden": true,
    className: "exclusion-border-bottom"
  }));
};
svs.selfExclusion.components.NationalSelfExclusion = NationalSelfExclusion;

 })(window);